// extracted by mini-css-extract-plugin
export default {"title":"PaymentPageTitle_title__9VA87"};